import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ImageUploading from 'react-images-uploading';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import hidePassword from '../../../assets/img/common/password_hide.svg';
import viewPassword from '../../../assets/img/common/password_show.svg';
import TickWhite from '../../../assets/img/icons/tick.svg';
import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import CustomCheckboxDropdown from '../../../components/CustomCheckboxDropdown/CustomCheckboxDropdown';
import AddSingleMemberDropdown from '../../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import { ClearSearchButton } from '../../../components/Search/searchStyles';
import DatePicker from '../../../components/SingleDatePicker/SingleDatePicker';
import { RoleOptions } from '../../../modules/constants';
import { ShowPasswordIcon } from '../../../styledComponents/authLayout';
import {
  ColoredButton,
  PrimaryButton,
  RadiusButton,
} from '../../../styledComponents/buttons';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  ContentHeader,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  PageTitle,
  RedStar,
} from '../../../styledComponents/common';
import {
  UploadButtonContainer,
  UploadImageButton,
} from '../../../styledComponents/members';
import {
  CheckBoxCircle,
  CheckBoxSquare,
} from '../../../styledComponents/tasks';
import {
  checkHtml,
  checkUrl,
  password_validate,
  validateEmail,
} from '../../../utils/helper';
import { InputSection } from '../../Tasks/CreateTask/createTaskStyles';
import { CheckBox } from '../../TimesheetApproval/AwaitingApprovals/awaitingApprovalStyles';

const AddMember = ({
  history,
  location,
  isLoading,
  getOfficesShortList,
  officesShortList,
  createMemberLoading,
  addMember,
  createdMemberInfo,
  updateMember,
  updateMemberLoading,
  updatedData,
  getMemberDetails,
  memberDetails,
  publicZoneList,
  getPublicZoneList,
}) => {
  const { t, i18n } = useTranslation();
  const [memberId, setMemberId] = useState(null);
  const [selectedOffices, setSelectedOffices] = useState([]);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mainEmail, setMainEmail] = useState('');
  const [storeEmail, setStoreEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [selectedRole, setSelectedRole] = useState('');
  const roleList = RoleOptions.map(role => {
    return {
      label: role.key,
      value: role.value,
    };
  });
  const [roleOptions, setRoleOptions] = useState([]);
  const [userCode, setUserCode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [images, setImages] = useState([]);
  const [imageUpdated, setImageUpdated] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState({
    label: 'Android',
    value: 'android',
  });
  const deviceOptions = [
    { label: 'Android', value: 'android' },
    { label: 'iOS', value: 'ios' },
  ];

  const [selectedPublicZone, setSelectedPublicZone] = useState();
  const [publicZoneOptions, setPublicZoneOptions] = useState([]);

  const [saveErrors, setSaveErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isOfficeDropdownOpen, setIsOfficeDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleOfficeDropdown = () => {
    setIsOfficeDropdownOpen(!isOfficeDropdownOpen);
  };

  const handleOfficeSelection = office => {
    const isSelected = selectedOffices.some(o => o.value === office.value);
    if (isSelected) {
      setSelectedOffices(selectedOffices.filter(o => o.value !== office.value));
    } else {
      setSelectedOffices([...selectedOffices, office]);
    }
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOfficeDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (location.search) {
      const queryParsed = queryString.parse(location.search);
      if (queryParsed.id) {
        setMemberId(queryParsed.id);
        getMemberDetails({ user_id: queryParsed.id });
      }
    }
    let newOptions = [];
    let isMatched = false;
    roleList &&
      roleList.map((role, i) => {
        if (localStorage.getItem('user_role') === 'admin' || isMatched) {
          newOptions.push(role);
        }
        if (role.value === localStorage.getItem('user_role')) {
          isMatched = true;
        }
      });
    setRoleOptions(newOptions);
  }, []);

  useEffect(() => {
    getPublicZoneList();
  }, []);


  useEffect(() => {
    if (memberId && memberDetails) {
      memberDetails.first_name && setFirstName(memberDetails.first_name);
      memberDetails.last_name && setLastName(memberDetails.last_name);
      if (memberDetails.memberships && memberDetails.memberships.length > 0) {
        const officeSelections = memberDetails.memberships
          .filter(membership => membership.office && membership.office_id)
          .map(membership => ({
            label: membership.office,
            value: membership.office_id,
          }));
        setSelectedOffices(officeSelections);
        if (officeSelections.length > 0) {
          setSelectedPublicZone({
            label: memberDetails.memberships[0].public_zone,
            value: memberDetails.memberships[0].public_zone_id,
          });
        }
      } else {
        setSelectedOffices([]);
      }
      memberDetails.email && setMainEmail(memberDetails.email);
      memberDetails.app_store_email &&
        setStoreEmail(memberDetails.app_store_email);
      memberDetails.role &&
        roleOptions &&
        roleOptions.length > 1 &&
        roleOptions.map(role => {
          role.value === memberDetails.role && setSelectedRole(role);
        });
      memberDetails.user_code && setUserCode(memberDetails.user_code);
      memberDetails.phone && setPhoneNumber(memberDetails.phone);
      memberDetails.avatar &&
        setImages([
          {
            data_url: memberDetails.avatar,
          },
        ]);
      memberDetails.device &&
        setSelectedDevice(
          deviceOptions.find(device => device.value === memberDetails.device),
        );
    }
  }, [memberDetails]);

  useEffect(() => {
    if (officesShortList) {
      if (officesShortList.length === 1 && !memberId) {
        const office = officesShortList[0];
        if (office.name && office.id) {
          setSelectedOffices([
            {
              label: office.name,
              value: office.id,
            },
          ]);
        }
      }

      if (officesShortList.length > 0) {
        const newArr = officesShortList
          .filter(office => office.name && office.id)
          .map(office => ({
            label: office.name,
            value: office.id,
          }));
        setOfficeOptions(newArr);
      }
    }
  }, [officesShortList, memberId]);

  useEffect(() => {
    if (roleOptions && roleOptions.length === 1) {
      setSelectedRole(roleOptions[0]);
    }
  }, [roleOptions]);

  useEffect(() => {
    if (createdMemberInfo && isSubmitted) {
      history.push({
        pathname: '/user/members',
        state: { from: 'create' },
      });
    }
  }, [createdMemberInfo]);

  useEffect(() => {
    if (updatedData && isSubmitted) {
      history.push({
        pathname: '/user/members',
        state: { from: 'update' },
      });
    }
  }, [updatedData]);

  useEffect(() => {
    if (selectedPublicZone?.value) {
      getOfficesShortList({
        public_zone_id: selectedPublicZone.value,
      });
    } else getOfficesShortList();
  }, [selectedPublicZone]);

  useEffect(() => {
    if (publicZoneList && publicZoneList.length > 0) {
      let newArr = [];
      publicZoneList.forEach(zone => {
        newArr.push({
          label: zone.name,
          value: zone.id,
        });
      });
      if (!selectedPublicZone?.value) {
        setSelectedPublicZone(newArr[0]);
      }
      setPublicZoneOptions(newArr);
    }
  }, [publicZoneList]);

  const onOfficeChange = selectedOptions => {
    let errors = { ...saveErrors };
    delete errors['office'];
    setSaveErrors(errors);
    setSelectedOffices([...selectedOptions]);
  };

  const onFirstNameChange = e => {
    let errors = { ...saveErrors };
    delete errors['firstName'];
    setSaveErrors(errors);
    setFirstName(e.target.value);
  };

  const onLastNameChange = e => {
    let errors = { ...saveErrors };
    delete errors['lastName'];
    setSaveErrors(errors);
    setLastName(e.target.value);
  };

  const onMainEmailChange = e => {
    let errors = { ...saveErrors };
    delete errors['mainEmail'];
    setSaveErrors(errors);
    setMainEmail(e.target.value);
  };

  const onStoreEmailChange = e => {
    let errors = { ...saveErrors };
    delete errors['storeEmail'];
    setSaveErrors(errors);
    setStoreEmail(e.target.value);
  };

  const onPasswordChange = e => {
    let errors = { ...saveErrors };
    delete errors['password'];
    setSaveErrors(errors);
    setPassword(e.target.value);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const onConfirmPasswordChange = e => {
    let errors = { ...saveErrors };
    delete errors['confirmPassword'];
    setSaveErrors(errors);
    setConfirmPassword(e.target.value);
  };

  const onRoleChange = e => {
    setSelectedRole(e);
  };

  const onUserCodeChange = e => {
    let errors = { ...saveErrors };
    delete errors['userCode'];
    setSaveErrors(errors);
    setUserCode(e.target.value);
  };

  const onDeviceChange = e => {
    setSelectedDevice(e);
  };

  const onPublicZoneChange = e => {
    setSelectedPublicZone(e);
    setSelectedOffices([]);
  };

  const onChangeImage = (imageList, addUpdateIndex) => {
    // data for submit
    setImages(imageList);
    if (memberId) {
      setImageUpdated(true);
    }
  };

  const onUpdateImage = () => {
    if (memberId) {
      setImageUpdated(true);
    }
  };

  const isAdminRole = (role) => {
    return role?.value === 'admin';
  };

  const handleSave = status => {
    if (checkError()) {
      let payload = {
        first_name: firstName,
        last_name: lastName,
        email: mainEmail.trim(),
        app_store_email: storeEmail.trim(),
        password: password,
        role: selectedRole.value,
        user_code: userCode,
        phone: phoneNumber,
        device: selectedDevice.value,
      };

      if (!isAdminRole(selectedRole)) {
        payload.memberships = selectedOffices.map(office => ({
          office: office.value,
          public_zone: selectedPublicZone.value,
        }));
      }

      if (status === 'update') {
        payload.user_id = memberId;
        if (imageUpdated) {
          images && images.length > 0 && images[0].file
            ? (payload.image = images[0].file)
            : (payload.image = '');
        }
        updateMember(payload);
      } else {
        images && images.length > 0 && images[0].file
          ? (payload.image = images[0].file)
          : (payload.image = null);
        addMember(payload);
      }
      setIsSubmitted(true);
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;
    if (!firstName.trim()) {
      formIsValid = false;
      saveErrors['firstName'] = 'First name is required';
    } else if (checkUrl(firstName)) {
      formIsValid = false;
      saveErrors['firstName'] = 'First name can not contain url.';
    } else if (checkHtml(firstName)) {
      formIsValid = false;
      saveErrors['firstName'] = 'Invalid First name';
    } else if (firstName.length > 80) {
      formIsValid = false;
      saveErrors['firstName'] = 'Maximum length 80 characters';
    }

    if (checkUrl(lastName)) {
      formIsValid = false;
      saveErrors['lastName'] = 'Last name can not contain url.';
    } else if (checkHtml(lastName)) {
      formIsValid = false;
      saveErrors['lastName'] = 'Invalid Last name';
    } else if (lastName.length > 80) {
      formIsValid = false;
      saveErrors['lastName'] = 'Maximum length 80 characters';
    }

    if (!isAdminRole(selectedRole)) {
      if (!selectedOffices.length) {
        formIsValid = false;
        saveErrors['office'] = 'Office must be selected.';
      }
    }

    if (!selectedRole.value.trim()) {
      formIsValid = false;
      saveErrors['role'] = 'Role must be selected.';
    }

    if (!mainEmail.trim()) {
      formIsValid = false;
      saveErrors['mainEmail'] = 'Main email is required';
    } else if (!validateEmail(mainEmail.trim())) {
      formIsValid = false;
      saveErrors['mainEmail'] = 'Please enter a valid main email address';
    }

    if (!storeEmail.trim()) {
      formIsValid = false;
      saveErrors['storeEmail'] = 'Store email is required';
    } else if (!validateEmail(storeEmail.trim())) {
      formIsValid = false;
      saveErrors['storeEmail'] = 'Please enter a valid store email address';
    }

    if (!memberId) {
      if (!password.trim()) {
        formIsValid = false;
        saveErrors['password'] = 'password is required';
      } else if (password.length < 7) {
        formIsValid = false;
        saveErrors['password'] = 'Password can not be less than 7 characters.';
      } else if (password.length > 32) {
        formIsValid = false;
        saveErrors['password'] = 'Password can not be more than 32 characters.';
      }
      if (password !== confirmPassword) {
        formIsValid = false;
        saveErrors['confirmPassword'] = 'password does not match';
      }
    } else {
      if (password.trim() && password.length < 7) {
        formIsValid = false;
        saveErrors['password'] = 'Password can not be less than 7 characters.';
      } else if (password.length > 32) {
        formIsValid = false;
        saveErrors['password'] = 'Password can not be more than 32 characters.';
      }
      if (password !== confirmPassword) {
        formIsValid = false;
        saveErrors['confirmPassword'] = 'password does not match';
      }
    }

    if (checkUrl(userCode)) {
      formIsValid = false;
      saveErrors['userCode'] = 'User Code can not contain url.';
    } else if (checkHtml(userCode)) {
      formIsValid = false;
      saveErrors['userCode'] = 'Invalid User Code';
    } else if (userCode.length > 80) {
      formIsValid = false;
      saveErrors['userCode'] = 'Maximum length 80 characters';
    }

    if (!selectedDevice.value) {
      formIsValid = false;
      saveErrors['device'] = 'Device must be selected.';
    }

    setSaveErrors(saveErrors);
    return formIsValid;
  };

  return (
    <div className="content">
      {isLoading || updateMemberLoading || createMemberLoading ? (
        <ComponentCircleLoader />
      ) : (
        <>
          <PageTitle>
            {memberId && memberId.length > 1 ? t('update_user') : t('add_user')}
          </PageTitle>
          <ContentHeader>
            <BackButtonComponent
              onClick={() => history.push('/user/members')}
              subTitle={t('back_to_all_members')}
            />
          </ContentHeader>
          <Container
            padding="30px"
            gap="20px"
            style={{ minHeight: `80vh`, alignContent: `start` }}
          >
            <CommonText name title fontSize="16px">
              {memberId && memberId.length > 1
                ? t('update_member_details')
                : t('add_member_details')}
            </CommonText>
            <InputSection>
              <InputWithLabelSection>
                <InputLabel>
                  {t('first_name')} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type="text"
                  placeholder={t('type_first_name')}
                  value={firstName}
                  onChange={e => onFirstNameChange(e)}
                  style={
                    saveErrors &&
                    saveErrors[`firstName`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors && saveErrors['firstName'] && (
                  <FormAlert>{saveErrors['firstName']}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>{t('last_name')}</InputLabel>
                <InputField
                  type="text"
                  placeholder={t('type_last_name')}
                  value={lastName}
                  onChange={e => onLastNameChange(e)}
                  style={
                    saveErrors &&
                    saveErrors[`lastName`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors && saveErrors['lastName'] && (
                  <FormAlert>{saveErrors['lastName']}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>
                  {t('main_email')} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type="email"
                  placeholder={t('type_main_email')}
                  value={mainEmail}
                  onChange={e => onMainEmailChange(e)}
                  style={
                    saveErrors &&
                    saveErrors[`mainEmail`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors && saveErrors['mainEmail'] && (
                  <FormAlert>{saveErrors['mainEmail']}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>
                  {t('store_email')} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type="email"
                  placeholder={t('type_store_email')}
                  value={storeEmail}
                  onChange={e => onStoreEmailChange(e)}
                  style={
                    saveErrors &&
                    saveErrors[`storeEmail`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors && saveErrors['storeEmail'] && (
                  <FormAlert>{saveErrors['storeEmail']}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection style={{ position: `relative` }}>
                <InputLabel>
                  {t('password')} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type={showPassword ? 'text' : 'password'}
                  placeholder={t('type_password')}
                  value={password}
                  onChange={e => onPasswordChange(e)}
                  style={
                    saveErrors &&
                    saveErrors[`password`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors && saveErrors['password'] && (
                  <FormAlert>{saveErrors['password']}</FormAlert>
                )}
                <ShowPasswordIcon
                  style={{ bottom: `6px` }}
                  src={showPassword ? hidePassword : viewPassword}
                  alt=""
                  onClick={e => toggleShowPassword(e)}
                />
              </InputWithLabelSection>
              <InputWithLabelSection style={{ position: `relative` }}>
                <InputLabel>
                  {t('confirm_password')} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type={showPassword ? 'text' : 'password'}
                  placeholder={t('type_password_again')}
                  value={confirmPassword}
                  onChange={e => onConfirmPasswordChange(e)}
                  style={
                    saveErrors &&
                    saveErrors[`confirmPassword`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors && saveErrors['confirmPassword'] && (
                  <FormAlert>{saveErrors['confirmPassword']}</FormAlert>
                )}
                <ShowPasswordIcon
                  style={{ bottom: `6px` }}
                  src={showPassword ? hidePassword : viewPassword}
                  alt=""
                  onClick={e => toggleShowPassword(e)}
                />
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>
                  {t('user_id')} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  type="text"
                  placeholder={t('type_user_id')}
                  value={userCode}
                  onChange={e => onUserCodeChange(e)}
                  style={
                    saveErrors &&
                    saveErrors[`userCode`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors && saveErrors['userCode'] && (
                  <FormAlert>{saveErrors['userCode']}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>
                  {t('phone_number')}
                  <RedStar>*</RedStar>
                </InputLabel>
                <PhoneInput
                  enableSearch
                  country={'sa'}
                  value={phoneNumber}
                  onChange={phone => setPhoneNumber(phone)}
                  inputClass="phone-number-input"
                  buttonClass="phone-number-flag-dropdown"
                />
                {saveErrors && saveErrors['phoneNumber'] && (
                  <FormAlert>{saveErrors['phoneNumber']}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>
                  {t('phone_type')} <RedStar>*</RedStar>
                </InputLabel>
                <Select
                  isSearchable
                  value={selectedDevice}
                  options={deviceOptions}
                  placeholder={t('select_device')}
                  onChange={e => onDeviceChange(e)}
                  styles={CreateProjectDropdown()}
                />
                {saveErrors && saveErrors['device'] && (
                  <FormAlert>{saveErrors['device']}</FormAlert>
                )}
              </InputWithLabelSection>{' '}
              <InputWithLabelSection>
                <InputLabel>
                  {t('role')} <RedStar>*</RedStar>
                </InputLabel>
                <Select
                  isSearchable
                  value={selectedRole}
                  options={roleOptions}
                  placeholder={t('select_role')}
                  isDisabled={roleOptions && roleOptions.length === 1}
                  onChange={e => {
                    onRoleChange(e);
                  }}
                  styles={CreateProjectDropdown()}
                />
                {saveErrors && saveErrors['role'] && (
                  <FormAlert>{saveErrors['role']}</FormAlert>
                )}
              </InputWithLabelSection>{' '}
              {!isAdminRole(selectedRole) && (
                <InputWithLabelSection>
                  <InputLabel>{t('public_zone')}</InputLabel>
                  <Select
                    isSearchable
                    value={selectedPublicZone}
                    options={publicZoneOptions}
                    placeholder={`${t('select_public_zone')}...`}
                    onChange={onPublicZoneChange}
                    styles={CreateProjectDropdown()}
                    filterOption={filterOption}
                  />
                </InputWithLabelSection>
              )}
              {!isAdminRole(selectedRole) && (
                <InputWithLabelSection>
                  <InputLabel>
                    {t('office')} <RedStar>*</RedStar>
                  </InputLabel>
                  <CustomCheckboxDropdown
                    options={officeOptions}
                    selectedOptions={selectedOffices}
                    onChange={onOfficeChange}
                    placeholder="select_offices"
                    countLabel="offices_selected"
                    error={saveErrors && saveErrors['office']}
                    errorMessage={saveErrors && saveErrors['office']}
                    disabled={selectedPublicZone?.value ? false : true}
                  />
                </InputWithLabelSection>
              )}
              <InputWithLabelSection>
                <InputLabel>{t('profile_picture')}</InputLabel>
                <ImageUploading
                  value={images}
                  onChange={onChangeImage}
                  dataURLKey="data_url"
                >
                  {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    onImageRemove,
                    isDragging,
                    dragProps,
                  }) => (
                    // write your building UI
                    <UploadButtonContainer
                      style={{ gridTemplateColumns: `1fr` }}
                    >
                      <UploadImageButton
                        style={isDragging ? { color: 'red' } : undefined}
                        onClick={onImageUpload}
                        {...dragProps}
                      >
                        {t('click_or_drop_here_to_upload')}
                      </UploadImageButton>
                      {/* <ColoredButton type="delete" onClick={onImageRemoveAll}>Remove image</ColoredButton> */}
                      {imageList.map((image, index) => (
                        <div
                          key={index}
                          style={{ gridColumn: `1 / span 2` }}
                          className="image-item"
                        >
                          <img src={image['data_url']} alt="" width="100" />
                          <UploadButtonContainer style={{ marginTop: `20px` }}>
                            <ColoredButton
                              type="blue"
                              onClick={() => {
                                onImageUpdate(index);
                                onUpdateImage();
                              }}
                            >
                              {t('update')}
                            </ColoredButton>
                            <ColoredButton
                              type="delete"
                              onClick={() => {
                                onImageRemove(index);
                                onUpdateImage();
                              }}
                            >
                              {t('remove')}
                            </ColoredButton>
                          </UploadButtonContainer>
                        </div>
                      ))}
                    </UploadButtonContainer>
                  )}
                </ImageUploading>
                {saveErrors && saveErrors['phoneNumber'] && (
                  <FormAlert>{saveErrors['phoneNumber']}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection />
              {memberId && memberId.length > 1 ? (
                <PrimaryButton
                  disabled={
                    !firstName ||
                    (!isAdminRole(selectedRole) && !selectedOffices.length) ||
                    !mainEmail ||
                    !storeEmail ||
                    !selectedRole ||
                    !phoneNumber
                  }
                  onClick={() => handleSave('update')}
                >
                  {updateMemberLoading ? (
                    <ButtonTextLoader
                      loadingText={t('update_user')}
                      fontSize="13px"
                    />
                  ) : (
                    t('update_user')
                  )}
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  disabled={
                    !firstName ||
                    (!isAdminRole(selectedRole) && !selectedOffices.length) ||
                    !mainEmail ||
                    !storeEmail ||
                    !password ||
                    !confirmPassword ||
                    !selectedRole ||
                    !userCode ||
                    !phoneNumber
                  }
                  onClick={() => handleSave()}
                >
                  {createMemberLoading ? (
                    <ButtonTextLoader
                      loadingText={t('create_a_new_user')}
                      fontSize="13px"
                    />
                  ) : (
                    t('create_a_new_user')
                  )}
                </PrimaryButton>
              )}
            </InputSection>
          </Container>
        </>
      )}
    </div>
  );
};

export default AddMember;
